import { useEffect } from "react";

const SectionSnap = ({ selectors, enabled = true }) => {
  useEffect(() => {
    if (!enabled) return undefined;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    let t;
    let lock = false;

    const snap = () => {
      if (lock) return;
      const y = window.scrollY;
      const vh = window.innerHeight;
      for (const sel of selectors) {
        const el = document.querySelector(sel);
        if (!el) continue;
        const d = el.offsetTop - y;
        if (d > vh * 0.15 && d < vh * 0.65) {
          lock = true;
          if (window.__lenis) {
            window.__lenis.scrollTo(el.offsetTop, { duration: 1 });
          } else {
            window.scrollTo({ top: el.offsetTop, behavior: "smooth" });
          }
          setTimeout(() => {
            lock = false;
          }, 1200);
          return;
        }
      }
    };

    const onScroll = () => {
      clearTimeout(t);
      t = setTimeout(snap, 280);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      clearTimeout(t);
    };
  }, [selectors, enabled]);

  return null;
};

export default SectionSnap;
